import { isNumber } from './number'

/**
 * Calculates the difference between an average and a reference value absolute and in percent.
 * Can be used to calculate the wasted fuel for given fuel consumption and consumption reference.
 *
 * @param {number} average - The average value
 * @param {number} reference - The reference value
 * @returns {{difference: number, differenceInPercent: number}}
 */
function calculateDiffAverageReference(average, reference) {
    if ((!average && !reference) || !isNumber(average) || !isNumber(reference) || isNaN(average) || isNaN(reference)) {
        return {
            difference: 0,
            differenceInPercent: 0
        }
    }

    const divisor = reference !== 0 ? reference : 1

    return {
        difference: average - reference,
        differenceInPercent: ((average - reference) * 100) / divisor
    }
}

export { calculateDiffAverageReference }
